import type { Clip } from '@/types'
import { clipSpeed, trimmedVolumePoints } from '@/types/timeline-editing'
import { quantizeToFrame } from './constants'

/** Normalize timing before windowing automation. Resize gestures pass their original clip as the source. */
export function normalizeClipUpdate(clip: Clip, updates: Partial<Clip>): Partial<Clip> {
  const normalized = { ...updates }
  if (normalized.startOnTimeline !== undefined) normalized.startOnTimeline = quantizeToFrame(normalized.startOnTimeline)
  if (normalized.duration !== undefined) normalized.duration = quantizeToFrame(normalized.duration)
  if (normalized.trimIn !== undefined)
    normalized.trimIn = clip.speed === undefined ? quantizeToFrame(normalized.trimIn) : Math.round(normalized.trimIn)
  if (normalized.trimOut !== undefined)
    normalized.trimOut = clip.speed === undefined ? quantizeToFrame(normalized.trimOut) : Math.round(normalized.trimOut)

  if (!clip.loop && updates.loop !== true && clip.speed !== undefined && normalized.duration !== undefined) {
    if (normalized.trimIn !== undefined && normalized.trimOut === undefined)
      normalized.trimIn = Math.round(clip.trimOut - normalized.duration * clip.speed)
    else if (normalized.trimOut !== undefined)
      normalized.trimOut = Math.round((normalized.trimIn ?? clip.trimIn) + normalized.duration * clip.speed)
  }
  if ('loop' in updates && !updates.loop) {
    const next = { ...clip, ...normalized }
    const windowDuration = (next.trimOut - next.trimIn) / clipSpeed(next)
    if (next.duration > windowDuration) {
      normalized.duration = quantizeToFrame(windowDuration)
      if (next.speed !== undefined) normalized.trimOut = Math.round(next.trimIn + normalized.duration * next.speed)
      normalized.fadeIn = Math.min(next.fadeIn ?? 0, normalized.duration) || undefined
      normalized.fadeOut = Math.min(next.fadeOut ?? 0, normalized.duration - (normalized.fadeIn ?? 0)) || undefined
    }
  }
  if (!('volumePoints' in updates)) {
    normalized.volumePoints = trimmedVolumePoints(clip, { ...clip, ...normalized }, clipSpeed(clip))
  }
  return normalized
}
